import { SvgProps } from "components/icons/types";

export const Wform = (props: SvgProps) => (
  <svg
    width="92"
    height="48"
    viewBox="0 0 92 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.538462"
      y="0.538462"
      width="90.9231"
      height="46.9231"
      rx="9.64336"
      fill="white"
    />
    <rect
      x="0.538462"
      y="0.538462"
      width="90.9231"
      height="46.9231"
      rx="9.64336"
      stroke="#EEE9FF"
      strokeWidth="1.07692"
    />
    <path
      d="M15.536 30L12.512 18.16H14.704L16.896 27.072L19.216 18.16H21.424L23.728 27.04L25.936 18.16H28.112L25.104 30H22.4L20.32 21.936L18.224 30H15.536ZM30.647 25.856V24.144H36.615V25.856H30.647ZM39.7957 30V18.16H47.9078V20.048H41.9717V23.408H47.1877V25.264H41.9717V30H39.7957ZM53.3848 30.16C52.4568 30.16 51.6674 29.952 51.0168 29.536C50.3661 29.12 49.8701 28.5813 49.5288 27.92C49.1981 27.248 49.0328 26.528 49.0328 25.76C49.0328 24.992 49.1981 24.2773 49.5288 23.616C49.8701 22.944 50.3661 22.4 51.0168 21.984C51.6674 21.568 52.4568 21.36 53.3848 21.36C54.3234 21.36 55.1128 21.568 55.7528 21.984C56.4034 22.4 56.8941 22.944 57.2248 23.616C57.5661 24.2773 57.7368 24.992 57.7368 25.76C57.7368 26.528 57.5661 27.248 57.2248 27.92C56.8941 28.5813 56.4034 29.12 55.7528 29.536C55.1128 29.952 54.3234 30.16 53.3848 30.16ZM53.3848 28.384C53.8648 28.384 54.2648 28.2613 54.5848 28.016C54.9154 27.7707 55.1661 27.4507 55.3368 27.056C55.5074 26.6507 55.5928 26.2187 55.5928 25.76C55.5928 25.2907 55.5074 24.8587 55.3368 24.464C55.1661 24.0693 54.9154 23.7493 54.5848 23.504C54.2648 23.2587 53.8648 23.136 53.3848 23.136C52.9154 23.136 52.5154 23.2587 52.1848 23.504C51.8541 23.7493 51.6034 24.0693 51.4328 24.464C51.2621 24.8587 51.1768 25.2907 51.1768 25.76C51.1768 26.2187 51.2621 26.6507 51.4328 27.056C51.6034 27.4507 51.8541 27.7707 52.1848 28.016C52.5154 28.2613 52.9154 28.384 53.3848 28.384ZM59.7482 30V21.52H61.8602V22.688H61.9402C62.0896 22.3573 62.3349 22.0533 62.6762 21.776C63.0176 21.4987 63.5296 21.36 64.2122 21.36C64.4256 21.36 64.6016 21.376 64.7402 21.408C64.8789 21.4293 64.9482 21.44 64.9482 21.44V23.504C64.9482 23.504 64.8682 23.4933 64.7082 23.472C64.5589 23.4507 64.3722 23.44 64.1482 23.44C63.4016 23.44 62.8362 23.648 62.4522 24.064C62.0682 24.48 61.8762 25.152 61.8762 26.08V30H59.7482ZM66.5545 30V21.52H68.6825V22.704H68.7625C68.8692 22.512 69.0185 22.3147 69.2105 22.112C69.4025 21.8987 69.6478 21.7227 69.9465 21.584C70.2558 21.4347 70.6345 21.36 71.0825 21.36C71.7118 21.36 72.2292 21.5093 72.6345 21.808C73.0398 22.1067 73.3385 22.4907 73.5305 22.96H73.5625C73.7758 22.5547 74.0905 22.1867 74.5065 21.856C74.9332 21.5253 75.4985 21.36 76.2025 21.36C76.7998 21.36 77.2958 21.4987 77.6905 21.776C78.0958 22.0427 78.3945 22.4053 78.5865 22.864C78.7892 23.3227 78.8905 23.8187 78.8905 24.352V30H76.7625V24.8C76.7625 24.3093 76.6398 23.9093 76.3945 23.6C76.1598 23.28 75.8078 23.12 75.3385 23.12C74.9652 23.12 74.6612 23.2213 74.4265 23.424C74.2025 23.616 74.0372 23.8613 73.9305 24.16C73.8345 24.4587 73.7865 24.7627 73.7865 25.072V30H71.6585V24.8C71.6585 24.3093 71.5412 23.9093 71.3065 23.6C71.0718 23.28 70.7145 23.12 70.2345 23.12C69.8612 23.12 69.5572 23.2213 69.3225 23.424C69.0985 23.616 68.9332 23.8667 68.8265 24.176C68.7305 24.4747 68.6825 24.7733 68.6825 25.072V30H66.5545Z"
      fill="url(#paint0_linear_2118_27219)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2118_27219"
        x1="12"
        y1="24"
        x2="80"
        y2="24"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
